import React from 'react'
import './style.css'


const Header = () => {

    return (
        <header>
            <img src="timbr_logo.png" alt="Timbr"></img>
            
        </header>
        

    )
}

export default Header;